<template>
    <accordion-item>
        <h2 slot="header">
            General Damages &mdash; {{currencyFormat(value)}}
        </h2>
        
        <psla-modal-content :duration="duration" :age="age" :value="value"></psla-modal-content>
    </accordion-item>
</template>

<script>
    import {mapActions} from 'vuex';
    import IconTooltip from 'components/IconTooltip';
    import Heading from 'components/modal/Heading';
    import Paragraph from 'components/modal/Paragraph';
    import Modal from 'components/modal/Modal';
    import ModalInTheWild from "components/modal/ModalInTheWild";
    import currencyFormat from "mixins/currencyFormat";
    import AccordionItem from "components/accordion/AccordionItem";
    import PslaModalContent from "./PslaModalContent";

    export default {
        name: "psla-modal",
        components: {
            AccordionItem,
            ModalInTheWild,
            Heading,
            Paragraph,
            IconTooltip,
            PslaModalContent,
            Modal
        },
        mixins: [
            currencyFormat
        ],
        props: {
            duration: {
                type: Number,
                required: true
            },
            age: {
                required: true
            },
            value: {
                required: true
            }
        },
        created() {
            this.init();
        },
        data() {
            return {
                table: {}
            }
        },
        computed: {
            tableResults() {
                if (!this.table[50]) {
                    return [];
                }
                let startRowIndex = (this.ageIndex < 60) ? 0 :
                    (this.ageIndex > 80) ? 80 :
                        this.ageIndex - 5;

                let startColumnIndex = this.columnIndexStart;
                let endColumnIndex = this.columnIndexEnd;

                return [
                    this.table[startRowIndex].slice(startColumnIndex, endColumnIndex),
                    this.table[startRowIndex + 5].slice(startColumnIndex, endColumnIndex),
                    this.table[startRowIndex + 10].slice(startColumnIndex, endColumnIndex)
                ];
            },
            columnIndexStart() {
                if (this.durationIndex < 2) {
                    return 0;
                }
                if (this.durationIndex === 12) {
                    return this.durationIndex - 2;
                }
                return this.durationIndex - 1;
            },
            columnIndexEnd() {
                if (this.durationIndex === 0) {
                    return this.durationIndex + 3;
                }
                return this.durationIndex + 2;
            },
            ageIndex() {
                const age = parseFloat(this.age);
                if (age < 50) {
                    return 50;
                }
                if (age > 90) {
                    return 90;
                }
                return Math.ceil(age / 5) * 5;
            },
            ageLabels() {
                return (this.ageIndex < 60) ? [50, 55, 60] :
                    (this.ageIndex > 80) ? [80, 85, 90] :
                        [this.ageIndex - 5, this.ageIndex, this.ageIndex + 5];
            },
            durationIndex() {
                if (this.duration < 3) {
                    return 0;
                }
                if (this.duration > 36) {
                    return 12;
                }
                return Math.floor(this.duration / 3) - 1;
            },
            durationLabels() {
                return this.durationIndex < 2 ?
                    [
                        "0-3",
                        "4-6",
                        "7-9"
                    ] :
                    this.durationIndex > 9 ? [
                        "31-33",
                        "34-36",
                        "37+"
                    ] : [
                        ((this.durationIndex - 1) * 3 - 2) + "-" + ((this.durationIndex - 1) * 3),
                        ((this.durationIndex) * 3 - 2) + "-" + ((this.durationIndex) * 3),
                        ((this.durationIndex + 1) * 3 - 2) + "-" + ((this.durationIndex + 1) * 3)
                    ];
            }
        },
        methods: {
            ...mapActions('psla', ['loadTable']),
            ...mapActions('modal', ['toggle']),
            init() {
                this.loadTable()
                    .then((table) => this.table = table);
            },
            toggleThis() {
                this.toggle('day-one-res-psla');
            },
            calcCellStyle(rowIndex, cellIndex) {
                if (this.durationIndex === 0) {
                    if (rowIndex === 1 && cellIndex === 0) {
                        return 'background:#9f9';
                    }
                    if (rowIndex === 1 || cellIndex === 0) {
                        return 'background:#efe';
                    }
                }

                if (this.durationIndex === 12) {
                    if (rowIndex === 1 && cellIndex === 2) {
                        return 'background:#9f9';
                    }
                    if (rowIndex === 1 || cellIndex === 2) {
                        return 'background:#efe';
                    }
                }

                if (this.durationIndex > 0 && this.durationIndex < 12) {
                    if (rowIndex === 1 && cellIndex === 1) {
                        return 'background:#9f9';
                    }
                    if (rowIndex === 1 || cellIndex === 1) {
                        return 'background:#efe';
                    }
                }

                return ''
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PslaModal.vue?e30bd41c